import axiosInstance from '../api/axios';
import {
  IContentViewHistoryResponse,
  IViewStatus,
  IViewStatusResponse,
  ViewContentType,
  ViewOrigin,
} from '../models/contentView';

/**
 * Finaliza um exercício SEM o aluno resolvê-lo (web, por slug).
 * Registra uma resposta errada no desempenho e marca o exercício como visto.
 * NÃO é toggle: chamar de novo só registra outra resposta errada. Para
 * desmarcar, use `setContentView(..., viewed: false)`.
 */
export async function finishExercise(
  slug: string,
  origin?: ViewOrigin
): Promise<IViewStatusResponse> {
  const response = await axiosInstance.post(
    `/exercises/${slug}/finish`,
    origin ? { origin } : undefined
  );
  return response.data;
}

/**
 * Finaliza um exercício sem resolver dentro de um conteúdo de curso (mobile).
 * Origem padrão no backend é `courses`. Responde apenas `{ ok: true }`.
 */
export async function finishCourseExercise(
  courseId: string,
  contentId: string,
  exerciseId: string,
  origin?: ViewOrigin
): Promise<IViewStatusResponse> {
  const response = await axiosInstance.post(
    `/mobile/courses/${courseId}/content/${contentId}/exercises/${exerciseId}/finish`,
    origin ? { origin } : undefined
  );
  return response.data;
}

interface ISetContentViewParams {
  contentType: ViewContentType;
  contentId: string;
  viewed: boolean;
  origin: ViewOrigin;
}

/**
 * Define explicitamente o status de visualização (não é toggle).
 * Use para desmarcar (`viewed: false`), inclusive exercícios finalizados.
 */
export async function setContentView(
  params: ISetContentViewParams
): Promise<IViewStatusResponse> {
  const response = await axiosInstance.post('/content-views', params);
  return response.data;
}

/** Consulta o status atual de visualização de um conteúdo. */
export async function getContentViewStatus(
  contentType: ViewContentType,
  contentId: string
): Promise<IViewStatus> {
  const response = await axiosInstance.get('/content-views/status', {
    params: { contentType, contentId },
  });
  return response.data;
}

export interface IContentViewHistoryParams {
  contentType?: ViewContentType;
  contentId?: string;
  origin?: ViewOrigin;
  page?: number;
  limit?: number;
}

/** Histórico paginado de visualizações do usuário. */
export async function getContentViewHistory(
  params: IContentViewHistoryParams = {}
): Promise<IContentViewHistoryResponse> {
  const response = await axiosInstance.get('/content-views/history', {
    params,
  });
  return response.data;
}
